// Read requests for GET action
const Reads = {
  baseComparisonInfo: 'base_comparison_info',
  changeGroups: 'change_groups',
  codeButton: 'code_button',
  codeowners: 'codeowners',
  threadPreviewPositioning: 'thread_preview_positioning',
  diffEntries: 'diff_entries',
  diffstat: 'diffstat',
  header: 'header',
  mergeBox: 'merge_box',
  mergeInstructions: 'merge_instructions',
  pendingReview: 'pending_review',
  statusChecks: 'status_checks',
  tabCounts: 'tab_counts',
  threadPreviews: 'thread_previews',
  diffViewUserSettings: 'user_diff_view_settings',
  diffContextLines: 'diff_entry_lines',
  richDiff: 'rich_diff',
  description: 'description',
} as const

// Mutation requests for PUT, POST, PATCH, DELETE actions
const Mutations = {
  abandonReview: 'abandon_review',
  addCommentReaction: 'add_comment_reaction',
  changeBase: 'change_base',
  cleanupCodespaces: 'cleanup_codespaces',
  convertToDraft: 'convert_to_draft',
  createReviewComment: 'create_review_comment',
  deleteHeadRef: 'delete_head_ref',
  // deleteReviewComment: (id: number) => `review_comments/${id}`,
  dequeuePullRequest: 'dequeue_pull_request',
  disableAutoMerge: 'disable_auto_merge',
  dismissReview: 'dismiss_review',
  enableAutoMerge: 'enable_auto_merge',
  generateChangeGroups: 'generate_change_groups',
  markReadyForReview: 'mark_ready_for_review',
  merge: 'merge',
  removeCommentReaction: 'remove_comment_reaction',
  reRequestReviewFromUser: 're_request_review_from_user',
  resolveThread: 'resolve_thread',
  runActionRequiredWorkflows: 'run_action_required_workflows',
  submitCopilotGroupsFeedback: 'submit_copilot_groups_feedback',
  submitReview: 'submit_review',
  submitSuggestedChanges: 'apply_suggestions',
  unresolveThread: 'unresolve_thread',
  updateReviewComment: 'update_review_comment',
  updatePullRequestBranch: 'update_pull_request_branch',
  updateTitle: 'update_title',
  updateShowChangeGroupsPreference: 'update_show_change_groups_preference',
  updateMergeBoxUserPreference: 'update_merge_box_user_preference',
  updateWhitespacePreference: 'update_whitespace_preference',
  hideComment: 'hide_comment',
  unhideComment: 'unhide_comment',
} as const

export const PageData = {
  ...Reads,
  ...Mutations,
} as const

export type PageDataKey = keyof typeof PageData
export type PageDataName = (typeof PageData)[PageDataKey]

export const PageDataReadKeys = Object.values(Reads)
export const PageDataMutationKeys = Object.values(Mutations)
